var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9319 8.16442C40.4545 7.09324 39.699 6.16943 38.7439 5.48897C37.7887 4.8085 36.6688 4.39621 35.5004 4.29492C34.3383 4.40229 33.2258 4.81739 32.2774 5.4975C31.329 6.17761 30.5789 7.09817 30.1044 8.16442L1.27843 58.0774C-1.70357 63.2249 0.745931 67.4494 6.67443 67.4494H64.3264C70.2549 67.4494 72.7044 63.2249 69.7224 58.0774L40.9319 8.16442ZM39.0504 56.7994H31.9504V49.6994H39.0504V56.7994ZM39.0504 42.5994H31.9504V21.2994H39.0504V42.5994Z",
    fill: "#FF6A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ecdb8a0a10d6175aac1bad770d107ffe.svg";
export { ForwardRef as ReactComponent };